import React, { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import * as S from '../styled';
import * as ST from './styled';
import { sendRequestByConnection, parseRequestByConnection } from '~/src/api/service-request/request-by-connection';
import PopupResult from '@ertelecom/ui-react/components/popups/popupResult';
import { RequestForm } from '~/src/components/RequestForm';
import { PRODUCTS } from '~/src/constants/index';
import { captureException } from '@sentry/node';

const resultType = {
    SUCCESS: 'success',
    ERROR: 'error',
};

export const ConnectRequest = () => {
    const city = useSelector(state => state.city.currentCity);
    const [popup, setPopup] = useState({
        isOrderOpened: false,
        isResultOpened: false,
        resultTitle: null,
        resultText: null,
        resultType: resultType.SUCCESS,
    });

    const submitRequest = useCallback(async(params) => {
        params.product_id = PRODUCTS.tv;
        try {
            const resp = await sendRequestByConnection(city.domain, params);
            const { ok, message, status } = parseRequestByConnection(resp);

            openPopupResult(ok, message, status);
        } catch (err) {
            captureException(err);
            openPopupResult(false, 'Не удалось отправить заявку.', 'error');
        }
    }, [city]);

    const openPopupResult = useCallback((ok, message, status) => {
        setPopup({
            isOrderOpened: false,
            isResultOpened: true,
            resultType: status,
            resultTitle: ok ? 'Заявка на подключение отправлена' : 'Произошла ошибка',
            resultText: ok ? 'Мы свяжемся с вами в ближайшее время' : message,
        });
    }, []);

    const closePopup = useCallback(() => {
        setPopup(state=>({
            ...state,
            isResultOpened: false,
        }));
    }, []);

    return (
        <S.Section bgColor='#f4f4f4'>
            <ST.InnerContainer>
                <ST.SectionTitle>Подключить телевидение</ST.SectionTitle>
                <RequestForm
                    isLoading={false}
                    message={null}
                    submitRequest={submitRequest}
                />
            </ST.InnerContainer>
            <PopupResult
                isOpen={popup.isResultOpened}
                onClose={closePopup}
                title={popup.resultTitle}
                text={popup.resultText}
                type={popup.resultType}
            />
        </S.Section>
    );
};
